import { useEffect, useMemo, useState } from "react";
import app from "nystem";
import { SelectInput, useSearch, useRouterQueryStore } from "nystem-components";

const SelectModelFilter = ({ model, view }) => {
  const [value, setValue] = useRouterQueryStore(model.saveId);
  const [storedModels, setStoredModels] = useState([]);
  useSearch({ view, id: "model", value, exact: true });

  useEffect(() => {
    let active = true;
    app.database.result.search({ count: 100000 }).then(({ data = [] }) => {
      if (active) setStoredModels([...new Set(data.map((result) => result.model).filter(Boolean))]);
    });
    return () => { active = false; };
  }, []);

  const option = useMemo(() => {
    const labels = new Map();
    Object.values(app.settings.extraction?.providers || {}).forEach((provider) => {
      Object.entries(provider.models || {}).forEach(([id, settings]) => {
        labels.set(id, settings.label || id);
      });
    });
    storedModels.forEach((id) => { if (!labels.has(id)) labels.set(id, id); });
    if (value && !labels.has(value)) labels.set(value, value);
    return [...labels].map(([_id, text]) => ({ _id, text })).sort((a, b) => a.text.localeCompare(b.text));
  }, [storedModels, value]);

  return <SelectInput model={{ ...model, option, clearButton: true, mandatory: false }} value={value} setValue={setValue} />;
};

export default SelectModelFilter;
